import React, { useState, useEffect } from 'react'

import { Button, Card, Form, Row, Typography, notification, Icon, Breadcrumb } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import CustomInput from '../../components/CustomInput/customInput'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const CreateTypes = function ({ match, history }) {
  const defaultFormValues = { active: true }
  const [formLayout] = useState('vertical')

  // Params url
  const { id, type } = match.params

  // Form configuration
  const [formValues, setFormValues] = useState({})

  const form = {
    initialValues: formValues,
    // Update-validation-rules-marker
    yupValidationUpdate: yup.object().shape({
      // Update-validation-rules-body-marker
      typeName: yup.string().max(60).typeError('must be string')
    }),

    // Create-validation-rules-marker
    yupValidationCreate: yup.object().shape({
      // Create-validation-rules-body-marker
      typeName: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('memberTypeDescription')))
    }),

    onSubmit: async (values) => {
      console.tron.log('submit values', values)
      if (!id) {
        const data = {
          ...values
        }
        storeTypes(data)
      } else {
        const payload = {
          data: {
            ...values
          },
          id
        }
        for (const key in payload.data) {
          if (payload.data[key] === null) {
            delete payload.data[key]
          }
        }

        updateTypes(payload)
      }
    }
  }

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.MEMBER_TYPE) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    if (id) {
      retrieveTypes(id)
    } else {
      setFormValues({})
    }

    // Use-effect-mount-marker
    return () => {
      setFormValues({})
    }
  }, [])

  useEffect(() => {
    if (!id) {
      setFormValues(defaultFormValues)
    }
  }, [id])

  // Api requests
  async function storeTypes(data) {
    try {
      await request(api.storeTypes(data, type))
      notification.success({
        description: getMessage('successStoreTypes'), // SuccessStoreTypes
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function retrieveTypes(typeId) {
    try {
      const response = await request(api.retrieveTypes(typeId, type))
      setFormValues({
        ...response
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateTypes(payload) {
    try {
      const { id, data } = payload
      await request(api.updateTypes(id, data, type))
      notification.success({
        description: getMessage('successupdateTypes'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  function getTitle() {
    let createTitle = ''
    let updateTitle = ''
    if (type === 'member') {
      createTitle = getMessage('createMemberTypes')
      updateTitle = getMessage('updateMemberTypes')
    } else if (type === 'location') {
      createTitle = getMessage('createLocationTypes')
      updateTitle = getMessage('updateLocationTypes')
    }

    return id !== null ? updateTitle : createTitle
  }

  function getBrandeCub() {
    let title = ''
    if (type === 'member') {
      title = 'Profissional'
    } else if (type === 'location') {
      title = 'Local'
    }

    return title
  }

  function renderHeader(submitForm) {
    const hasAccess = validRule(RULES.MEMBER_TYPE)

    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => history.push('/')}>
              <Icon
                type="home"
                theme="filled"
                style={{ fontSize: '16px', color: '#263447' }}
                onClick={() => history.push('/')}
              />
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => history.push(`/types/${type}/list`)}>
              Tipo de {getBrandeCub()}
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {match.params.id ? `Atualizar Tipo de ${getBrandeCub()}` : `Cadastrar Tipo de ${getBrandeCub()}`}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={() => submitForm()}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <Formik
        enableReinitialize
        validationSchema={!id ? form.yupValidationCreate : form.yupValidationUpdate}
        initialValues={formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          const setFieldValueWithState = (field, value) => {
            setFormValues({
              ...formValues,
              [field]: value
            })
            return setFieldValue(field, value)
          }

          return (
            <Form className="memberTypes-form" layout={formLayout} onSubmit={handleSubmit}>
              {renderHeader(submitForm)}

              <Card className="ant-card gx-card ant-card-bordered">
                <Typography.Title className="default-header-title" level={3}>
                  {getTitle()}
                </Typography.Title>
                <Row type="flex" justify="start">
                  <CustomSwitch
                    field="active"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    unCheckedChildren={getMessage('label.inactive')}
                    checkedChildren={getMessage('label.active')}
                  />
                </Row>
                <Row type="flex" justify="start">
                  <CustomInput
                    field="typeName"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>
              </Card>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default CreateTypes
